import { connect } from 'react-redux';

import { changeQuickShopSelectedVariant } from '../actions';
import QuickShopPdp from '../components/QuickShopPdp';

const mapStateToProps = state => {
  return {
    selectedVariant: state.selectedQuickShopVariant,
    currentOrder: state.currentOrder,
    splitTreatments: state.splitTreatments,
  };
};

const mapDispatchToProps = dispatch => ({
  changeSelectedVariant: variant => {
    dispatch(changeQuickShopSelectedVariant(variant));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickShopPdp);
